import React from "react";

function StockFormSection({ number, title, description, children, className = "" }) {
  return (
    <section className={`stock-form-section ${className}`.trim()}>
      <header className="stock-form-section__header">
        <span className="stock-form-section__number" aria-hidden="true">{number}</span>
        <div>
          <h3>{title}</h3>
          {description ? <p>{description}</p> : null}
        </div>
      </header>
      <div className="stock-form-section__body">{children}</div>
    </section>
  );
}

export default StockFormSection;
